import { createAsyncThunk } from "@reduxjs/toolkit";
import { getSupplierWiseOutflowApi, getSupplierOutflowMatrixApi } from "../../../apiservice/accounts";

export const fetchSupplierOutflow = createAsyncThunk(
  "supplierOutflow/fetch",
  async (filters, { rejectWithValue }) => {
    try {
      const res = await getSupplierWiseOutflowApi({
        supplierId: filters.supplierId || null,
        fromDate: filters.fromDate || undefined,
        toDate: filters.toDate || undefined,
      });

      return res.data || { accounts: [], total_outflow: 0 };
    } catch (err) {
      if (err.response?.status === 401) {
        sessionStorage.clear();
        window.location.reload();
        return rejectWithValue("Authentication failed");
      }

      return rejectWithValue(
        err.response?.data?.message ||
          err.message ||
          "Failed to fetch supplier outflow data"
      );
    }
  }
);

export const fetchSupplierOutflowMatrix = createAsyncThunk(
  "supplierOutflow/fetchMatrix",
  async (filters, { rejectWithValue }) => {
    try {
      const res = await getSupplierOutflowMatrixApi({
        year: filters.year,
        supplierId: filters.supplierId || null,
      });

      return res.data || { rows: [] };
    } catch (err) {
      if (err.response?.status === 401) {
        sessionStorage.clear();
        window.location.reload();
        return rejectWithValue("Authentication failed");
      }

      return rejectWithValue(
        err.response?.data?.message ||
          err.message ||
          "Failed to fetch supplier outflow matrix"
      );
    }
  }
);
